import { useQuery } from '@tanstack/react-query'
import { Task } from "../../backend/types/task.ts"

export const useGetTasks = (params?: Record<string, string>) => useQuery<Task[]>({ queryKey: ['task', params] })
